"use strict";

/**
 * Dual-logging proxy: logs to both New Relic and DataDog RUM
 * Intercepts addPageAction, noticeError, setCustomAttribute
 */

import { getDataDogRUM } from '../datadog/agent';
export function createDualLoggingAgent(newRelicAgent, enableDataDog = true) {
  const datadogEnabled = enableDataDog && process.__browser__;
  const handler = {
    get(target, prop) {
      if (prop === 'addPageAction') {
        return (name, attributes) => {
          target.addPageAction(name, attributes);
          if (datadogEnabled) {
            try {
              getDataDogRUM().addAction(name, attributes);
            } catch (error) {
              if (process.env.NODE_ENV !== "production") console.warn('[DataDog] addAction failed:', error);
            }
          }
        };
      }
      if (prop === 'noticeError') {
        return (error, customAttributes) => {
          target.noticeError(error, customAttributes);
          if (datadogEnabled) {
            try {
              const errorObj = typeof error === 'string' ? new Error(error) : error;
              getDataDogRUM().addError(errorObj, customAttributes);
            } catch (err) {
              if (process.env.NODE_ENV !== "production") console.warn('[DataDog] addError failed:', err);
            }
          }
        };
      }
      if (prop === 'setCustomAttribute') {
        return (key, value) => {
          target.setCustomAttribute(key, value);
          if (datadogEnabled) {
            try {
              getDataDogRUM().setGlobalContextProperty(key, value);
            } catch (error) {
              if (process.env.NODE_ENV !== "production") console.warn('[DataDog] setGlobalContextProperty failed:', error);
            }
          }
        };
      }
      const value = target[prop];
      return typeof value === 'function' ? value.bind(target) : value;
    }
  };
  return new Proxy(newRelicAgent, handler);
}
export const DualLoggingAgent = createDualLoggingAgent;